module.exports = __webpack_public_path__ + "static/media/unforeseen-corners.85e82442.jpg";